import { SalesOrderResult } from "src/app/ui/models/domains/pbm/financial-satatement/sales-order-result";
import { FinancialStatementViewItem } from "../view-items/financial-statement-view-item";

export class FinancialStatementHeaderViewItemFactory {
  
  static calculateTotalBalance(salesOrderResults: SalesOrderResult[]): number {
    let totalBalance: number = 0;
    salesOrderResults.forEach((salesOrderResultItem) => {
      if (salesOrderResultItem.getSalesAction() === "Confirma") {
        salesOrderResultItem.getSalesOrderItemResultList().forEach((salesOrderResultItemListItem) => {
          totalBalance += salesOrderResultItemListItem.getPrice();
        });
      }
    });
    return totalBalance;
  }

  static calculateIndividualTotalBalance(financialStatementViewItemList: FinancialStatementViewItem[]): number {
    let totalBalance: number = 0;
    financialStatementViewItemList.forEach((financialStatementViewItem) => {
      totalBalance += financialStatementViewItem.getPrice();
    });
    return totalBalance;
  }

  static parseFinancialStatementViewItemList(salesOrderResults: SalesOrderResult[], beneficiaryList: any[]): FinancialStatementViewItem[] {
    const financialStatementViewItemList: FinancialStatementViewItem[] = [];
    salesOrderResults.forEach((salesOrderResultItem) => {
      const transactionDate = salesOrderResultItem.getTransactionDate();
      const networkName = salesOrderResultItem.getNetworkName();
      const beneficiary = beneficiaryList.find((benef) => benef.socialNumber === salesOrderResultItem.getBeneficiarySocialNumber());
      salesOrderResultItem.getSalesOrderItemResultList().forEach((salesOrderResultItemListItem) => {
        const financialStatementViewItem = new FinancialStatementViewItem();
        financialStatementViewItem.setSalesAction(salesOrderResultItem.getSalesAction());
        financialStatementViewItem.setDate(transactionDate);
        financialStatementViewItem.setNetworkName(networkName);
        financialStatementViewItem.setProductName(
          salesOrderResultItemListItem.getProductResult().getEan() + " - " + salesOrderResultItemListItem.getProductResult().getName(),
        );
        financialStatementViewItem.setproductQuantity(salesOrderResultItemListItem.getProductQuantity());
        financialStatementViewItem.setDiscountValue(salesOrderResultItemListItem.getDiscountValue());
        financialStatementViewItem.setEmploymentPayrollValue(salesOrderResultItemListItem.getEmploymentPayrollValue());
        financialStatementViewItem.setPrice(salesOrderResultItemListItem.getPrice());
        financialStatementViewItem.setUnitPrice(salesOrderResultItemListItem.getUnitPrice());
        financialStatementViewItem.setSubsidyValue(salesOrderResultItemListItem.getSubsidyValue());
        financialStatementViewItem.setBeneficiaryName(beneficiary ? beneficiary.name : null);
        financialStatementViewItem.setBeneficiarySocialNumber(beneficiary ? beneficiary.socialNumber : salesOrderResultItem.getBeneficiarySocialNumber());
        financialStatementViewItemList.push(financialStatementViewItem);
      });
    });
    return financialStatementViewItemList;
  }
}
